import * as React from 'react';

interface IAccordionContext {
  type?: string;
  disabled?: boolean;
  expanded?: boolean;
  toggle?: (e) => void;
  expandedIcon?: React.ReactElement;
  unExpandedIcon?: React.ReactElement;
  showExpandIcon?: boolean;
  checkIfExpanded?: (e) => void;
}

const AccordionContext = React.createContext<IAccordionContext>({});

export { AccordionContext };
